module.exports = __webpack_public_path__ + "img/front_40.a1fc31c7.svg";